//packages
import React, { Component } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
//components
import Landing from './Landing';
//assets
// import logo from '../../../assets/images/gov.ua.white.png';
import { connect } from 'react-redux';

import { isEmpty } from '../utils/is-empty';
import setAuthToken from '../utils/setAuthToken.js';
import queryString from 'query-string';
import { loginUser, logoutUser } from '../../../redux/actions/auth.action';
import Header from './Header/Header';
import headerStyle from './headersStyle';
import SectionFooter from './landingComponents/SectionFooter';
import { withStyles, List, ListItem, Button } from '@material-ui/core';

const navOptions = [
  { link: '/#video', option: 'Відео' },
  { link: '/#advantages', option: 'Переваги' },
  { link: '/#serviceList', option: 'Послуги' },
  // { link: '/#importance', option: 'Важливість' },
  { link: '/#persons', option: 'Користувачі' },
  { link: '/#roles', option: 'Ролі' },
  { link: '/#connecting', option: 'Приєднатись' },
  { link: '/#spreading', option: 'Поширеність' },
  // { link: "/#comments", option: 'Відгуки' }
];

class LandingPage extends Component {
  constructor(props) {
    super(props);

    // this.props.logoutUser()
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      communitiesConnected: 0,
      communitiesReady: 0,
      communitiesInprogress: 0,
      statError: false,
    };
  }

  getCommunityConectionInfo = async () => {
    try {
      // const result = await axios.get('http://10.3.0.44:8088/stat/countconn');
      const result = await axios.get(`/stat/countcom`);
      const { connected, ready, inprogress } = result.data;
      this.setState({
        communitiesConnected: connected,
        communitiesReady: ready,
        communitiesInprogress: inprogress,
      });
    } catch (error) {
      this.setState({ statError: true });
    }
  };

  async componentDidMount() {
    // info about connected communities
    this.getCommunityConectionInfo();

    if (this.props.auth.isAuthenticated) {
      this.props.history.push('/register');
    }

    const query = queryString.parse(this.props.location.search);

    if (!isEmpty(query.token)) {
      // const decoded = jwt_decode(query.token);
      localStorage.setItem('jwtToken', query.token);
      //this.props.setCurrentUser(decoded)
      // console.log(query.token);

      setAuthToken(query.token);
      //Bearer
      const token = query.token.slice(7);
      // console.log(token);
      this.props.loginUser(token);
      // props.history.push('/profile-page')
      // this.setState(state => {
      //   return {
      //     open: !state.open
      //   }
      // })
    } else {
      this.props.logoutUser();
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    const { classes } = this.props;
    const { communitiesConnected, communitiesReady, communitiesInprogress, statError } = this.state;

    return (
      <div className="landingPage">
        <Header
          absolute
          brand="ДП ІОЦ"
          color="transparent"
          links={
            <List className={classes.list + ' ' + classes.mlAuto}>
              {navOptions.map((point, i) => {
                return (
                  <ListItem key={i}>
                    <Button
                      href={point.link}
                      className={classes.navLink}
                      //  onClick={e => e.preventDefault()}
                      // variant="contained"
                      // color="transparent"
                      to={point.link}
                    >
                      {point.option}
                    </Button>
                  </ListItem>
                );
              })}
            </List>
          }
        />
        {/* <header>
          <Navbar
            color="light"
            dark
            expand="md"
            className="bg-gradient text-white"
            style={{ paddingBottom: '1.5rem', paddingTop: '1.5rem' }}
          >
            <Container>
              <NavbarBrand href="https://www.gov.ua/">
                <img src={logo} alt="buttonGovUa" />
              </NavbarBrand>
              <NavbarToggler onClick={this.toggle} />
              <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className="ml-auto" navbar>
                  {navOptions.map((point, i) => {return (<NavItem>
                    <HashLink
                     activeStyle={{
                      outline: '1px solid #fff',
                      fontFamily: "proba_pro_bold"
                    }}
                  className="nav-link text-white-btn" to={point.link}>{point.option}</HashLink>
                  </NavItem>)})}
                  
                </Nav>
              </Collapse>
            </Container>
          </Navbar>
        </header> */}

        {/* // style={{backgroundImage:`url(${prapor})`,height:"88vh",border:"1px solid", backgroundSize: "cover"}} */}

        <Landing
          communitiesConnected={communitiesConnected}
          communitiesReady={communitiesReady}
          communitiesInprogress={communitiesInprogress}
          statError={statError}
        />
        <SectionFooter />
      </div>
    );
  }
}

LandingPage.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    auth: state.socialCommunity,
  };
};

export default withRouter(withStyles(headerStyle)(connect(mapStateToProps, { loginUser, logoutUser })(LandingPage)));
